export default __webpack_public_path__ + "soil-500-64ceef02de02f7ec3acb595bf0862958.webp";